module.exports = __webpack_public_path__ + "99844aa07d06e3ff7e117374d2be1677.png";